import momentz from 'moment-timezone';
import moment from 'moment';
import constants from './constants';

const asString = (str) => fromDate(asDate(str));

const fromDate = (dt) =>
	// const options = { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' }
	dt.toLocaleDateString('en-us');
const fromNotifDate = (dt) => dt.tz('America/New_York').format('MMM DD, hh:mm A');

const fromNotifDateTimezone = (dt, timezone_name) =>
	dt.tz(timezone_name || 'America/New_York').format('MMM DD, hh:mm A');

const alertExpirationDate = (dt) => dt.tz('America/New_York').format('MMM-DD-YYYY, hh:mm A');

const toHumanReadableDate = (str) => {
	const date = moment(str);

	return date.format('dddd, MMM DD, YYYY');
};

const assDate = (str) => {
	const year = str.substr(0, 4);
	const month = str.substr(5, 2);
	const day = str.substr(8, 2);
	const hours = str.substr(11, 2);
	const minutes = str.substr(14, 2);
	const seconds = str.substr(17, 2);
	const dt = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;

	const postedOn = momentz(dt);
	return postedOn;
};

const asDate = (str) => {
	const year = str.substr(0, 4);
	const month = str.substr(5, 2);
	const day = str.substr(8, 2);

	const dt = `${month}/${day}/${year}`;
	// return new Date(dt)
	return dt;
};

const fmtTime = (str) => moment.utc(str, 'HH:mm:00').format('hh:mm A');

const fmtLocationTime = (time) => {
	const localTime = moment.utc(time).format('hh:mm A');
	return localTime;
};

const fmtLocationDate = (date) => {
	const parsedDate = moment.utc(date).format('MM/DD/YYYY');
	return parsedDate;
};
const fmtLocationTimeFromDate = (date, time, tz) => {
	const parsedDate = moment.utc(date).format('MM/DD/YYYY');
	const turnedTime = momentz(`${parsedDate} ${time}`).tz(tz).format('hh:mm A');
	return turnedTime;
};

const fmtLocationFromDate = (format, date, tz) => {
	const turnedTime = momentz(date)
		.tz(tz || constants.est_timezone)
		.format(format);
	return turnedTime;
};

const fmtTransformTz = (date, tz) => {
	const turnedTime = momentz(date).tz(tz);
	return turnedTime;
};

const fmtTimeWeek = (str) => moment.utc(str, 'HH:mm:00').format('hh:mmA');

const fmtNotifTime = (str) => {
	if (str === undefined || str === '' || str === null) {
		return '';
	}
	let hour = str.substr(11, 2);
	const minutes = str.substr(14, 2);
	// const seconds = str.substr(17, 2)
	let mer = 'AM';
	if (hour > 12) {
		hour -= 12;
		mer = 'PM';
	}
	return `${hour}:${minutes}${mer}`;
};

const fmtCalendarTime = (str) => moment(str).format('hh:mmA');

const dateFilterFormat = (str) => {
	const month = str.substr(0, 2);
	const day = str.substr(3, 2);
	const year = str.substr(6, 4);

	const dt = `${year}-${month}-${day}`;
	return dt;
};
const getyear = (str) => {
	const year = str.substr(11, 4);
	return year;
};
const getmonth = (str) => {
	const month = str.substr(4, 3);
	switch (month) {
		case 'Jan':
			return '01';
		case 'Feb':
			return '02';
		case 'Mar':
			return '03';
		case 'Apr':
			return '04';
		case 'May':
			return '05';
		case 'Jun':
			return '06';
		case 'Jul':
			return '07';
		case 'Aug':
			return '08';
		case 'Sep':
			return '09';
		case 'Oct':
			return '10';
		case 'Nov':
			return '11';
		case 'Dec':
			return '12';
	}
};

const serverDateToMmDdYy = (str) => {
	if (!str) return '';
	// yy-mm-dd > mm-dd-yy
	return str != '' ? `${str.substr(5, 2)}-${str.substr(8, 2)}-${str.substr(0, 4)}` : '';
};

const clientDateToYyMmDd = (str) =>
	// mm-dd-yy > yy-mm-dd
	str != '' ? `${str.substr(6, 9)}-${str.substr(0, 2)}-${str.substr(3, 2)}` : '';
const clientDateToYyMmDdRequirement = (str) =>
	// mm-dd-yy > yy-mm-dd
	str != '' ? `${str.substr(6, 9)}-${str.substr(0, 2)}-${str.substr(3, 2)}` : null;
const convert24HrTo12Hr = (time) => {
	time = moment.utc(time, 'HH:mm:ss');
	const shiftTime = time.format('h:mmA');
	return shiftTime;
};

const get24FormatHours = (time) => {
	time = moment.utc(time, 'HH:mm:ss');
	return time;
};

const zeroFill = (num, len) => (Array(len).join('0') + num).slice(-len);

// Format time into 06:00 AM pattern
const convertTimeWithMin = (timeFmt, tm) => {
	tm = moment(tm, 'HH:mm').format(timeFmt);
	return tm;
};

const convertTimeWithMinLocal = (timeFmt, tm) => {
	tm = moment.utc(tm);
	tm = moment(tm).local().format(timeFmt);
	return tm;
};
// converting shift start or end time to the format for the side panel to local
const convertPanelShiftCardToLocal = (time) => {
	time = moment.utc(time, 'YYYY-MM-DD HH:mm:ss');
	time = moment(time).local().format('ddd, MMM DD, YYYY hh:mm A');
	return time;
};

// converting shift start or end time to the format for the side panel to other timezone
const convertPanelShiftCardToTZ = (time, timezone) => {
	time = moment.utc(time, 'YYYY-MM-DD HH:mm:ss');
	time = momentz.tz(time, timezone).format('ddd, MMM DD, YYYY hh:mm A');
	return time;
};

// convert time to other timezone
const convertTimeWithMinTZ = (timeFmt, tm, timezone) => {
	tm = moment.utc(tm);
	tm = momentz.tz(tm, timezone).format(timeFmt);
	return tm;
};

// Format date and time (2017-12-19T18:18:10Z) into 'Tuesday, December 19' pattern
const convertDateWithDay = (dt) => {
	dt = moment.utc(dt, 'YYYY-MM-DD HH:mm:ss');
	const shiftDate = dt.format('dddd, MMMM DD');
	return shiftDate;
};
// Format date and time (2017-12-19T18:18:10Z) into 'Dec 19, 2017' pattern
const convertDateMonthYear = (date) => {
	date = moment.utc(date, 'YYYY-MM-DD HH:mm:ss');
	date = date.format('MMM DD, YYYY');
	return date;
};
// Format date and time (2017-12-19T18:18:10Z) into 'O6:00PM' pattern
const convertToTimeFromDateTime = (dt) => {
	dt = moment.utc(dt, 'YYYY-MM-DD HH:mm:ss');
	const shiftDate = dt.format('hh:mm A');
	return shiftDate;
};

// Format date and time (2017-12-19T18:18:10Z) into parameter pattern
const formatDateTime = (format, dt) => {
	dt = moment.utc(dt, 'YYYY-MM-DD HH:mm:ss');
	const shiftDate = dt.format(format);
	return shiftDate;
};

// Format date and time (2017-12-19T18:18:10Z) into 'Dec 04, 2017 O6:00PM' pattern
const convertToDateWithTime = (dt) => {
	dt = moment.utc(dt, 'YYYY-MM-DD HH:mm:ss');
	const Datetime = dt.format('MMM DD,YYYY hh:mm A');
	return Datetime;
};
const formatEditDate = (format, dt) => {
	dt = moment(dt, 'YYYY-MM-DD HH:mm:ss');
	const shiftDate = dt.format(format);
	return shiftDate;
};

const convertFormat = (format, hr, min) => {
	let timeStr = '';
	if (hr < 0 || min < 0) {
		timeStr = '-';
	}
	if (hr < 10 && hr > 0) {
		timeStr += '0';
	}

	if (hr !== undefined) {
		timeStr += `${hr.toString().replace('-', '')}:`;
	} else {
		timeStr = '00:';
	}

	if (min !== undefined) {
		timeStr += formatDate.zeroFill(min, 2).replace('-', '');
	} else {
		timeStr += '00';
	}
	return timeStr;
};

const calculateStartEndDiff = (start_date, end_date) => {
	const startTime = moment(start_date);
	startTime.set({ second: 0 });
	const end = moment(end_date);
	end.set({ second: 0 });
	const duration = moment.duration(end.diff(startTime));
	const days = duration.days();
	let hours = duration.hours();
	const min = duration.minutes();

	if (days != 0) {
		hours += days * 24;
	}
	const dateDifference = formatDate.convertFormat('hh:mm', hours, min);
	return dateDifference;
};

const convertTimeToLocal = (dt) => {
	dt = moment(dt, 'HH:mm:ss');
	return dt;
};
// check if shift has already started
const isSameDayTimeShift = (shiftDate, tz, shiftStartTime, shiftEndTime) => {
	const shiftStartDate = convertTimeWithMinTZ('DD MMM YYYY', shiftDate, tz);
	const currentTime = convertTimeWithMinTZ('YYYY-MM-DD HH:mm:ss', moment(), tz);

	const beforeTime = moment(convertTimeWithMinTZ('YYYY-MM-DD HH:mm:ss', shiftStartTime));
	const afterTime = moment(convertTimeWithMinTZ('YYYY-MM-DD HH:mm:ss', shiftEndTime));

	if (moment(shiftStartDate).isSame(moment(currentTime), 'day')) {
		if (moment(currentTime).isBetween(beforeTime, afterTime)) {
			return false; // shift has already started
		}
		if (moment(currentTime).isAfter(beforeTime)) {
			return false; // shift time has passed
		}
	} else if (moment(currentTime).isAfter(beforeTime)) {
		return false; // shift is completed
	}
	return true;
};

const formatDate = {
	alertExpirationDate,
	asDate,
	assDate,
	asString,
	calculateStartEndDiff,
	clientDateToYyMmDd,
	clientDateToYyMmDdRequirement,
	convert24HrTo12Hr,
	convertDateMonthYear,
	convertDateWithDay,
	convertFormat,
	convertPanelShiftCardToLocal,
	convertPanelShiftCardToTZ,
	convertTimeToLocal,
	convertTimeWithMin,
	convertTimeWithMinLocal,
	convertTimeWithMinTZ,
	convertToDateWithTime,
	convertToTimeFromDateTime,
	dateFilterFormat,
	fmtCalendarTime,
	fmtLocationDate,
	fmtLocationFromDate,
	fmtLocationTime,
	fmtLocationTimeFromDate,
	fmtNotifTime,
	fmtTime,
	fmtTimeWeek,
	fmtTransformTz,
	formatDateTime,
	formatEditDate,
	fromDate,
	fromNotifDate,
	fromNotifDateTimezone,
	get24FormatHours,
	getmonth,
	getyear,
	isSameDayTimeShift,
	serverDateToMmDdYy,
	toHumanReadableDate,
	zeroFill
};

export default formatDate;
